var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('sub-visual', {
    attrs: {
      "subTabNone": "",
      "sh": "개인정보처리방침",
      "bg": "/images/sub/visual/sv6.jpg"
    }
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('terms-component', {
    attrs: {
      "code": "privacy"
    }
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }